module.exports = __webpack_public_path__ + "media/images/twitter-488906d68555c7c3d7a66a520606464f.svg";